import { PageId } from 'constants/pages'
import { TPageMapValue } from 'models/common.model'
import { lazy } from 'react'
import { PageIdWoofzHlwn75 } from './pages'

type TIdToPageMapWoofzHlwn75 = Record<PageIdWoofzHlwn75, TPageMapValue>

export const ID_TO_PAGE_MAP_WOOFZ_HLWN_75: TIdToPageMapWoofzHlwn75 = {
  [PageId.SUBSCRIPTIONS_PAGE_HLWN_75]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_hlwn/woofz_hlwn_75/pages/subscriptions/SubscriptionHlwn75'
      ).then((m) => ({
        default: m.SubscriptionsHlwn75,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz_hlwn/woofz_hlwn_75/pages/subscriptions/SubscriptionHlwn75'
      ),
  },
  [PageId.CHAT_UPSELL_HLWN_75]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_hlwn/woofz_hlwn_75/pages/upsell/ChatUpsellNewFlow'
      ).then((m) => ({
        default: m.ChatUpsellNewFlow,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz_hlwn/woofz_hlwn_75/pages/upsell/ChatUpsellNewFlow'
      ),
  },
  [PageId.UPSELL_HLWN_75]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_hlwn/woofz_hlwn_75/pages/upsell/Upsell').then(
        (m) => ({
          default: m.Upsell,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_hlwn/woofz_hlwn_75/pages/upsell/Upsell'),
  },
  [PageIdWoofzHlwn75.DOWNLOAD_HLWN_75]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_hlwn/woofz_hlwn_75/pages/download-app/DownloadApp'
      ).then((m) => ({
        default: m.DownloadApp,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz_hlwn/woofz_hlwn_75/pages/download-app/DownloadApp'
      ),
  },
  [PageIdWoofzHlwn75.ACCOUNT_NOVE8]: {
    Component: lazy(() =>
      import('nove8/modules/account/AccountNove8').then((m) => ({
        default: m.AccountNove8,
      })),
    ),
    preload: () => import('nove8/modules/account/AccountNove8'),
  },
}
